import { Component } from 'react';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { LIST_BRANCH } from 'automation-ui-action-features/actions/ActionMetadataConfigs';
import { DEFAULT_BRANCH_INDEX, isDefaultBranchIndex } from 'automation-ui-action-features/records/recordsUtils';
import StaticBranchName from 'automation-ui-action-features/actions/static-branch/StaticBranchName';
import { getFollowedBranchIndex } from 'automation-ui-log-events/records/LogEvent/utils';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import PreviewCard from 'automation-ui-canvas/components/test-flow/PreviewCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class BranchActionPreview extends Component {
  getConnection() {
    const {
      logEvent: {
        action: {
          connection
        }
      }
    } = this.props;
    return connection;
  }
  getBranch(branchIndex) {
    const connection = this.getConnection();
    return connection.getBranches().get(branchIndex);
  }
  getBranchOverrideOptions() {
    const {
      logEvent: {
        action
      },
      flowObjectTypeId,
      getActionOutputsForTargetActionById
    } = this.props;
    const makeOption = (branch, branchIndex) => {
      const labelString = this.getBranchLabelByBranchIndex(branchIndex);
      const labelNode = action.isStaticBranch() && !isDefaultBranchIndex(branchIndex) ? /*#__PURE__*/_jsx(StaticBranchName, {
        action: action,
        branch: branch,
        branchIndex: branchIndex,
        propertyTypeId: flowObjectTypeId,
        getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
      }) : labelString;
      return {
        text: labelString,
        value: branchIndex,
        disabled: branch && branch.getConnector() === null,
        dropdownText: labelNode,
        buttonText: labelNode
      };
    };
    const defaultBranchOption = makeOption(null, DEFAULT_BRANCH_INDEX);
    const branchOptions = this.getConnection().getBranches().map(makeOption);
    if (action.isABTestBranch()) {
      return [...branchOptions];
    }
    return [...branchOptions, defaultBranchOption];
  }
  getBranchLabelByBranchIndex(branchIndex) {
    if (isDefaultBranchIndex(branchIndex)) {
      const connection = this.getConnection();
      return connection.getDefaultBranchName() || I18n.text('platformTest.badges.branch.otherwiseDefaultBranchName');
    }
    const branch = this.getBranch(branchIndex);
    const branchName = branch.getBranchName() || I18n.text('platformTest.badges.branch.defaultBranchName', {
      position: branchIndex + 1
    });
    return branchName;
  }
  getFollowedBranchIndex() {
    const {
      logEvent: {
        action
      },
      branchIndexOverride,
      logEvent
    } = this.props;
    const followedBranchIndex = action.isABTestBranch() ? 0 : getFollowedBranchIndex(logEvent);
    return !branchIndexOverride || isNaN(branchIndexOverride) ? followedBranchIndex : branchIndexOverride;
  }
  renderContent() {
    const {
      logEvent: {
        objectId
      },
      flowObjectTypeId,
      onBranchIndexOverrideChange
    } = this.props;
    const followedBranchIndex = this.getFollowedBranchIndex();
    const options = this.getBranchOverrideOptions();
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "platformTest.branch.content",
        options: {
          objectName: /*#__PURE__*/_jsx(ObjectNameReference, {
            id: objectId,
            objectTypeId: flowObjectTypeId
          })
        }
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformTest.branch.branchSelect.label"
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          options: options,
          onChange: evt => onBranchIndexOverrideChange(evt.target.value),
          value: followedBranchIndex
        })
      })]
    });
  }
  render() {
    const {
      logEvent: {
        timestamp
      },
      actionLabel,
      renderContentOnly
    } = this.props;
    const actionMetadata = LIST_BRANCH;
    const {
      icon,
      theme
    } = actionMetadata;
    if (renderContentOnly) {
      return this.renderContent();
    }
    return /*#__PURE__*/_jsx(PreviewCard, {
      theme: theme,
      icon: icon,
      header: actionLabel,
      content: this.renderContent(),
      timestamp: timestamp,
      "data-test-id": "test-action-preview"
    });
  }
}
export default BranchActionPreview;